import React, { useEffect, useRef } from 'react';
import Header from '../common/Header';
import carrier from '../../assets/images/partners/carrier.jpg'
import unionaire from '../../assets/images/partners/unionaire.png'
import LG from '../../assets/images/partners/LG.jpg'
import { useLanguage } from '../../store/languageContext';
import { motion } from 'framer-motion'
import translate from '../../utils/translation';

const Advantages = () => {
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('black');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);

    const advantages = [
        {
            number: '10',
            text: translate[language]['advantagesNumbers1']
        },
        {
            number: '1,500+',
            text: translate[language]['advantagesNumbers2']
        },
        {
            number: '4.9',
            text: translate[language]['advantagesNumbers3']
        },
    ];
    return (
        <section id='advantages' ref={sectionRef} className="container mx-auto landing-section">
            <div className='flex justify-between'>
                <Header text={translate[language]['advantagesHeader']} />
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className='flex justify-end'>
                    <div className='inline font-semibold text-[60px] leading-[60px] mr-[250px]'>
                        {translate[language]['advantagesTitle1']}
                        <div className='flex items-center justify-between mt-3' >
                            <span>
                                {translate[language]['advantagesTitle2']}
                            </span>
                            <span className={`inline-flex ${language === 'ar' ? 'translate-x-[60px]' : 'translate-x-[-60px]'} `}>
                                <div className={`w-[60px] h-[60px] bg-[#ccc] border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[1] ${language === 'ar' ? 'translate-x-[-150%]' : 'translate-x-[150%]'}`}>
                                    <img src={carrier} alt='carrier' className='w-full' />
                                </div>
                                <div className={`w-[60px] h-[60px] bg-[#ccc] border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[2] ${language === 'ar' ? 'translate-x-[-100%]' : 'translate-x-[100%]'}`}>
                                    <img src={unionaire} alt='unionaire' className='w-full' />
                                </div>
                                <div className={`w-[60px] h-[60px] bg-[#ccc] border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[3] ${language === 'ar' ? 'translate-x-[-50%]' : 'translate-x-[50%]'}`}>
                                    <img src={LG} alt='LG' className='w-full' />
                                </div>
                                <div className={`w-[60px] h-[60px] bg-[#ccc] border-[4px] border-white shadow-sm rounded-full overflow-hidden flex items-center justify-center z-[4] ${language === 'ar' ? 'translate-x-[-0%]' : 'translate-x-[0%]'}`}>
                                    <span className='text-2xl'>
                                        +16
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </motion.div>
            </div>
            <div>
                {advantages.map((advantage, index) => (
                    <motion.div
                        initial={{ y: (index + 1) * 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: (index + 1) * 0.6, ease: 'easeOut' }}
                        viewport={{ once: true }}
                        key={index} className='border-b flex justify-between items-end pb-[30px] font-semibold'>
                        <span className='text-[#589EEE] text-[150px] leading-[150px]'>
                            {advantage.number}
                        </span>
                        <span className='uppercase'>
                            {advantage.text}
                        </span>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export { Advantages };